/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cloneDeep, isEqual, sortedIndex } from 'lodash';

import SettingsService from 'apps/shared/src/libs/services/settings';

import CollapsibleSelect from 'shared/ui/components/form-components/CollapsibleSelect.vue';
import InputWithActions from 'shared/ui/components/form-components/InputWithActions.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';

const settingsService = new SettingsService();

const notifyMessages = {
    success: 'live_sessions.preferences.messages.settings_save_success',
    failure: 'live_sessions.preferences.messages.settings_save_failure',
    add: 'live_sessions.preferences.messages.blocked_words_add_success',
    addLanguage: 'live_sessions.preferences.messages.blocked_words_add_language_success',
    deleteLanguage: 'live_sessions.preferences.messages.blocked_words_delete_language_success',
    deleteWord: 'live_sessions.preferences.messages.blocked_words_delete_word_success',
    restoreWords: 'live_sessions.preferences.messages.blocked_words_restored_words_success',
};

const __vue_script__ = {
    name: 'WordCloudBlockedWordsPreferences',

    components: {
        CollapsibleSelect,
        InputWithActions,
        Toggler
    },

    props: {
        eid: {
            required: true,
            type: String
        }
    },

    data() {
        return {
            loaded: false,
            blockedWordsEnabled: false,
            blockedWords: { },
            previousBlockedWords: { },
            languageToRestore: null,
            visibleAddLanguageInput: false,
            newLanguageName: '',
        };
    },

    computed: {
        /**
         * @returns {string[]}
         */
        languages() {
            return Object.keys(this.blockedWords).sort().map(key => ({ name: key, words: this.blockedWords[key] }));
        },

        /**
         * @returns {boolean}
         */
        createBtnDisabled() {
            return !this.newLanguageName || !!this.blockedWords[this.newLanguageName];
        },

        /**
         * @returns {boolean}
         */
        noChange() {
            return isEqual(this.blockedWords, this.previousBlockedWords);
        }
    },

    async created() {
        const settings = await this.$services.settings.getSetting(this.eid, 'polling');
        this.blockedWordsEnabled = settings['blocked-words-enabled'];
        this.blockedWords = settings['blocked-words'];
        this.previousBlockedWords = cloneDeep(this.blockedWords);
        this.loaded = true;
    },

    methods: {
        /**
         * @param {string} languageName
         * @param {string} word
         */
        addWord(languageName, word) {
            const words = this.blockedWords[languageName];
            words.splice(sortedIndex(words, word.toLowerCase()), 0, word.toLowerCase());
            this.previousBlockedWords[languageName] = cloneDeep(words);
            this.save({ action: 'add', languageName, word });
        },

        /**
         * @param {string} languageName
         * @param {string} word
         */
        async deleteWord(languageName, word) {
            this.$delete(this.blockedWords[languageName], this.blockedWords[languageName].indexOf(word));
            await this.save({ action: 'deleteWord', languageName, word });
            this.languageToRestore = { languageName, words: cloneDeep(this.previousBlockedWords[languageName]) };
            this.$delete(this.previousBlockedWords[languageName], this.blockedWords[languageName].indexOf(word));
        },

        /**
         * @param {boolean} value
         */
        onTogglerInput(value) {
            this.blockedWordsEnabled = value;
            this.save({ action: 'success' });
        },

        /**
         * @param {string} languageName
         */
        onClickDeleteLanguage(languageName) {
            this.$modal.show('dialog', {
                title: this.$t('live_sessions.preferences.word_cloud_blocked_words.delete_language'),
                text: this.$t('live_sessions.preferences.messages.blocked_words_delete_language_confirm'),
                buttons: [
                    {
                        title: this.$t('general.cancel'),
                        default: true,
                        class: 'btn'
                    },
                    {
                        title: this.$t('general.delete'),
                        handler: async () => {
                            this.deleteLanguage(languageName);
                            this.$modal.hide('dialog');
                        },
                        class: 'btn btn-danger'
                    }
                ]
            });
        },

        /**
         * @param {string} languageName
         */
        async deleteLanguage(languageName) {
            this.$delete(this.blockedWords, languageName);
            await this.save({ action: 'deleteLanguage', languageName });
            this.languageToRestore = { languageName, words: cloneDeep(this.previousBlockedWords[languageName] || []) };
            this.$delete(this.previousBlockedWords, languageName);
        },

        async showAddLanguageInput() {
            this.visibleAddLanguageInput = true;
            await this.$nextTick();
            this.$refs.addLanguageInput.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        },

        hideAddLanguageInput() {
            this.visibleAddLanguageInput = false;
            this.newLanguageName = '';
        },

        async addLanguage() {
            const languageName = this.newLanguageName;
            this.$set(this.blockedWords, languageName, []);
            this.$set(this.previousBlockedWords, languageName, []);
            this.hideAddLanguageInput();

            await this.$nextTick();

            const index = this.languages.findIndex(language => language.name === languageName);
            const selectComponent = this.$refs.blockedWordsSelects[index];
            selectComponent.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });

            this.save({ action: 'addLanguage', languageName });
        },

        async restoreWords() {
            const { languageName, words } = this.languageToRestore || {};
            if (languageName) {
                this.$set(this.blockedWords, languageName, words);
                this.languageToRestore = null;
                await this.save({ action: 'restoreWords', languageName });
                this.$notify.close('wordcloud-blocked-words-restore');
            }
        },

        /**
         * @param {object} o - context
         * @param {string} o.action - one of 'add', 'addLanguage', 'deleteLanguage', 'changeWords'
         * @param {string} o.languageName - name of the language
         * @param {string} [o.word] - word to add
         */
        async save({ action = '', languageName, word = '' }) {
            try {
                await settingsService.saveSetting(this.eid, 'polling', {
                    ['blocked-words-enabled']: this.blockedWordsEnabled,
                    ['blocked-words']: this.blockedWords
                });
            } catch {
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('live_sessions.preferences.messages.settings_save_failure').toString(),
                    type: 'error',
                    duration: 5000
                });
                return;
            }

            const allowRestore = action === 'deleteWord';
            if (allowRestore) {
                this.$notify.close('wordcloud-blocked-words-restore');
            }

            await this.$nextTick();

            this.$notify({
                ...(allowRestore ? { id: 'wordcloud-blocked-words-restore' } : {}),
                group: 'flashes',
                text: this.$i18n.t(notifyMessages[action], [languageName, word]).toString(),
                type: 'success',
                duration: 5000,
                data: (allowRestore ? {
                    button: this.$i18n.t('live_sessions.preferences.word_cloud_blocked_words.restore').toString(),
                    action: () => {
                        this.restoreWords();
                    } } : null)
            });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],staticClass:"word-cloud-blocked-words-preferences"},[_c('toggler',{staticClass:"enable-toggler",attrs:{"value":_vm.blockedWordsEnabled,"name":"word-cloud-blocked-words-enabled-toggler","on-label":"live_sessions.preferences.word_cloud_blocked_words.toggler_label","off-label":"live_sessions.preferences.word_cloud_blocked_words.toggler_label"},on:{"input":_vm.onTogglerInput}}),(_vm.blockedWordsEnabled)?[_c('button',{staticClass:"btn btn-primary add-language-button",on:{"click":_vm.showAddLanguageInput}},[_vm._v(_vm._s(_vm.$t('live_sessions.preferences.word_cloud_blocked_words.add_language'))),_c('i',{staticClass:"icon-plus"})]),_vm._l((_vm.languages),function(language){return _c('collapsible-select',{key:language.name,ref:"blockedWordsSelects",refInFor:true,staticClass:"blocked-words-select",attrs:{"label":language.name,"placeholder":_vm.$t('live_sessions.preferences.word_cloud_blocked_words.add_word'),"value":language.words,"options":language.words,"name":((language.name.toLowerCase()) + "-blocked-words-select"),"optionsLabel":null,"hint-after-label":"hint-after-label","multiple":"multiple","taggable":"taggable","hide-selected":"hide-selected","start-collapsed":"start-collapsed"},on:{"remove":function($event){return _vm.deleteWord(language.name, $event)},"tag":function($event){return _vm.addWord(language.name, $event)}},scopedSlots:_vm._u([{key:"inside-label",fn:function(){return [_c('a',{staticClass:"delete-button",attrs:{"href":"#"},on:{"click":function($event){return _vm.onClickDeleteLanguage(language.name)}}},[_vm._v(_vm._s(_vm.$t('general.delete')))])]},proxy:true}],null,true)})}),(_vm.visibleAddLanguageInput)?_c('input-with-actions',{ref:"addLanguageInput",attrs:{"placeholder":_vm.$t('live_sessions.preferences.word_cloud_blocked_words.add_language'),"type":"text","name":"new-language-name"},model:{value:(_vm.newLanguageName),callback:function ($$v) {_vm.newLanguageName=$$v},expression:"newLanguageName"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.hideAddLanguageInput}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]),_c('button',{staticClass:"btn btn-success",attrs:{"disabled":_vm.createBtnDisabled},on:{"click":_vm.addLanguage}},[_vm._v(_vm._s(_vm.$t('general.create')))])]):_vm._e()]:_vm._e()],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "WordCloudBlockedWordsPreferences.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__